import React from "react";
import { useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";

class Precertificados extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accionCombo: Api.loadCatalogue("cat_accion"),
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      orden: {},
      nivelUsuario: localStorage.nivel_actual,
      buscar: {},
    };

    this.handleOpenPago = this.handleOpenPago.bind(this);
    this.handleChangeStatusOrder = this.handleChangeStatusOrder.bind(this);
  }

  //busqueda = {};
  mi_grid = {};
  handleOpenPago(e) {
    Swal.fire({
      title: "Validación de Pago",
      input: "text",
      inputLabel: "Número de referencia de la orden de pago:",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      reverseButtons: true,
      inputValidator: (numeroPago) => {
        // Si el valor es válido, debes regresar undefined. Si no, una cadena
        if (!numeroPago) {
          return "Por favor ingresa el número de referencia de la orden de pago.";
        } else {
          return undefined;
        }
      },
    }).then((resultado) => {
      if (resultado.value) {
        let orden = {
          id: e.target.dataset.orden,
          referencia: resultado.value,
        };

        this.setState({ orden: orden });
        this.handleChangeStatusOrder(3, 5);
      }
    });
  }
  //Funcion para postear el status
  handleChangeStatusOrder(e, type) {
    Api.loading(true);

    Api.fetch(
      "app/updateStatusOrder",
      {
        id: this.state.orden.id,
        status: e,
        referencia: this.state.orden.referencia,
        tramite_id: 19,
      },
      "PUT"
    ).then((r) => {
      // No necesitamos refrescar, solo invocar la pagina actual del grid de establecimientos
      //this.mi_grid.go(1, this.busqueda.data());
      this.mi_grid.go(1);
      // Luego cerramos el modal
      Api.loading(false);
      this.setState({ modalRegente: false });

      Swal.fire({
        title: "Orden de pago actualizada",
        icon: "success",
        text: r.message,
        timer: 1500, //1.5 seconds
        showConfirmButton: false,
      });
    });
  }

  componentDidMount() {
    // si el usuario no es nivel medico veterinario ipsa redireccionamos a home
    if (this.state.nivelUsuario !== "7") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getOrderPrecertificadosUser",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_orden: {
          label: "Folio Orden",
        },
        nombre_servicio: {
          label: "Servicio",
        },
        nombre_cliente: {
          label: "Nombre",
        },
        fecha_orden: {
          label: "Fecha",
          render: (me) => {
            me.innerHTML = me.data.fecha_orden
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        estatus: {
          label: "Estado",
        },
        clave_referencia: {
          label: "Orden de pago",
          render: (e) => {
            if (e.data.clave_referencia === null) {
              e.innerHTML = `<button data-orden="${e.data.id}"  class="btn bg-gradient-green"><i data-orden="${e.data.id}"  class="fas fa-money-check-alt"></i></button>`;
              e.querySelector("button").addEventListener(
                "click",
                this.handleOpenPago
              );
            }
          },
        },
      },
    };

    this.mi_grid = Api.grid(grid);

     let busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio",
            label: "Folio",
            placeHolder: "Ingresa el folio de la orden",
            cols: 3,
          },
        },
        {
          select: {
            type: "text",
            name: "accion",
            label: "Solicitud",
            cols: 3,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.accionCombo.forEach((s) => {
                if (s.id === "1" || s.id === "3003")
                  me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Nombre",
            cols: 8,
            value: "",
          },
        },
        {
          select: {
            name: "estatus",
            label: "Estado",
            placeHolder: "Estado",
            cols: 2,
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.estatusTramiteCombo.forEach((s) => {
                me.innerHTML += `<option value="${s.id}">${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscar: busqueda.data() });
              let search = this.state.buscar;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);

              //this.mi_grid.go(1, this.busqueda.data());
            },
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Home
          </li>
          <li className="breadcrumb-item active">
            Créditos para solicitar precertificado y/o constancias de
            exportación
          </li>
        </ol>
        <h1 className="page-header">
          Créditos para solicitar precertificado y/o constancias de exportación
        </h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Precertificados auth={auth} history={history} {...props} />;
};
